import React from 'react'
import { Link } from 'react-router-dom'
import { Query, Mutation } from 'react-apollo'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import Select from 'react-select'
import { CSVLink } from 'react-csv'
import _debounce from 'lodash/debounce'

import clientiSearch from 'graphql/queries/clientiSearch'
import clientiEmailSearch from 'graphql/queries/clientiEmailSearch'
import clientiNewsletterSearch from 'graphql/queries/clientiNewsletterSearch'
import miniMe from 'graphql/queries/miniMe'
import agenti from 'graphql/queries/agenti'
import zone from 'graphql/queries/zone'
import interessi from 'graphql/queries/interessi'
import clientiUI from 'graphql/queries/clientiUI'
import updateClientiUI from 'graphql/mutations/updateClientiUI'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'
import FormControl from 'material-ui/Form/FormControl'
import SimpleSelect from 'material-ui/Select'
import MenuItem from 'material-ui/Menu/MenuItem'
import InputAdornment from 'material-ui/Input/InputAdornment'
import FormControlLabel from 'material-ui/Form/FormControlLabel'
import Checkbox from 'material-ui/Checkbox'

// material-ui icons
import RecentActors from 'material-ui-icons/RecentActors'
import Search from 'material-ui-icons/Search'
import Add from 'material-ui-icons/Add'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import IconCard from 'components/Cards/IconCard.jsx'
import {
  PortalFilter,
  PortalIndicators,
  getPortalInterestFromFilter,
  getPortalsFromInterests,
  getStoredPortalFilter,
} from 'components/Portal/Portal.jsx'

import tableStyle from 'assets/jss/material-dashboard-pro-react/components/tableStyle.jsx'
import './Clienti.css'

const FiltroClienti = (props) => {
  return (
    <div style={{ float: 'right', marginTop: -70, ...props.style }}>
      <TextField
        label="Cerca..."
        id="cerca"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search />
            </InputAdornment>
          ),
          value: props.value,
          onChange: props.onChange,
        }}
      />
    </div>
  )
}

const TableHeaderLink = ({ field, label, sort, onChange }) => {
  return (
    <a href="#" onClick={onChange(field)}>
      {label} {sort === field + '_ASC' && '▲'} {sort === field + '_DESC' && '▼'}
    </a>
  )
}

const TableClienti = (props) => {
  const {
    classes,
    searchQuery,
    onlyDaRicontattare,
    quantoInteressato,
    agenteSelezionato,
    zoneMulti,
    interesse,
    zonaEsclusa,
    interesseEscluso,
    iscrittoDa,
    nascondiProposteAcquisto,
    provenienza,
    portalFilter,
    sortFields,
    onChangeSortField,
    page = 1,
    onPageChange,
    csvOpen,
    csvEmailOpen,
    csvNewsletterOpen,
    onShowCsv,
    onHideCsv,
    onShowCsvEmail,
    onHideCsvEmail,
    onShowCsvNewsletter,
    onHideCsvNewsletter,
  } = props

  const PAGE_SIZE = 15

  let andConditions = []
  if (onlyDaRicontattare) {
    andConditions.push({ daRicontattare: true })
    andConditions.push({ telNonRisposte: 0 })
  }
  if (agenteSelezionato !== '') {
    andConditions.push({ agenteId: agenteSelezionato })
  }
  if (quantoInteressato !== '') {
    andConditions.push({ quantoInteressato })
  }

  if (zoneMulti && zoneMulti.length > 0) {
    andConditions.push({
      OR: zoneMulti.map((z) => ({ zone_join: { nome: z } })),
    })
  }
  if (interesse) {
    andConditions.push({ interessi_join: { nome: interesse } })
  }
  if (zonaEsclusa) {
    andConditions.push({ zone_none: { nome: zonaEsclusa } })
  }
  if (interesseEscluso) {
    andConditions.push({ interessi_none: { nome: interesseEscluso } })
  }

  const portalInterest = getPortalInterestFromFilter(portalFilter)
  if (portalInterest) {
    andConditions.push({ interessi_any: { nome: portalInterest } })
  }

  if (provenienza && provenienza !== 'TUTTI') {
    andConditions.push({ provenienza })
  }

  if (iscrittoDa && iscrittoDa !== 'TUTTI') {
    andConditions.push({ iscrittoDa })
  }
  if (nascondiProposteAcquisto && nascondiProposteAcquisto !== 'NESSUNO') {
    andConditions.push({ nascondiProposteAcquisto })
  }

  const variables = {
    search: searchQuery,
    limit: PAGE_SIZE,
    offset: (page - 1) * PAGE_SIZE,
    where: {
      AND: andConditions,
    },
    orderBy: sortFields,
  }

  const variablesCsv = {
    search: searchQuery,
    limit: 10000,
    offset: 0,
    where: {
      AND: andConditions,
    },
    orderBy: sortFields,
  }

  const variablesCsvEmail = {
    search: searchQuery,
    limit: 500000,
    offset: 0,
    where: {
      AND: andConditions,
    },
  }

  const variablesCsvNl = {
    search: searchQuery,
    limit: 500000,
    offset: 0,
    where: {
      AND: andConditions,
    },
    // orderBy: sortFields,
  }

  return (
    <Query query={clientiSearch} variables={variables} fetchPolicy="cache-and-network">
      {({ loading, error, data }) => {
        if (loading) return <p>Loading...</p>
        if (error) return <p>Error :(</p>

        return (
          <div>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeadCell}>Portale</TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="nome" label="Nome" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="comune" label="Comune" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="dataUltimoContatto" label="Data ultimo contatto" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="dataUltimaRichiesta" label="Data ultima richiesta" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="email" label="E-mail" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="telefono" label="Telefono" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <TableHeaderLink field="agenteId" label="Agente" sort={sortFields[0]} onChange={onChangeSortField} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.clientiSearch.nodes.map((cliente) => (
                  <TableRow key={cliente.id}>
                    <TableCell className={classes.tableCell}>
                      <PortalIndicators portals={getPortalsFromInterests(cliente.interessi)} />
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: cliente.daRicontattare ? 'bold' : 'normal',
                      }}
                    >
                      <Link
                        to={`/clienti/${cliente.id}`}
                        style={{
                          color: cliente.nuovoClienteFlag ? '#2ab32a' : 'auto',
                        }}
                      >
                        {cliente.nome ? cliente.nome : <i>Senza nome</i>}
                      </Link>
                    </TableCell>
                    <TableCell className={classes.tableCell}>{cliente.comune}</TableCell>
                    <TableCell className={classes.tableCell}>{cliente.dataUltimoContatto ? moment(cliente.dataUltimoContatto).format('DD/MM/YYYY') : ''}</TableCell>
                    <TableCell className={classes.tableCell}>{cliente.dataUltimaRichiesta ? moment(cliente.dataUltimaRichiesta).format('DD/MM/YYYY') : 'Nessuna richiesta'}</TableCell>
                    <TableCell className={classes.tableCell}>
                      <a href={`mailto:${cliente.email}`}>{cliente.email}</a>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <a href={`tel:${cliente.telefono}`}>{cliente.telefono}</a>
                    </TableCell>
                    <TableCell className={classes.tableCell}>{cliente.agente ? cliente.agente.nome : <i>Senza agente</i>}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <ReactPaginate
              previousLabel={'« precedente'}
              nextLabel={'successiva »'}
              breakLabel="..."
              breakClassName={'break-me'}
              pageCount={Math.ceil(data.clientiSearch.totalCount / PAGE_SIZE)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={onPageChange}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              initialPage={page ? page - 1 : 0}
            />

            <Query query={miniMe}>
              {({ loading, error, data: { me } }) => {
                if (loading) return <p>Loading...</p>
                if (error) return <p>Error :(</p>

                return (
                  <div>
                    {me.ruolo !== 'AGENTE' && (
                      <React.Fragment>
                        <hr />

                        {!csvEmailOpen && !csvOpen && (
                          <Button color="primary" onClick={onShowCsv}>
                            Prepara CSV (max 10000 contatti)
                          </Button>
                        )}

                        {!csvEmailOpen && csvOpen && (
                          <div style={{ marginTop: 20 }}>
                            <Query query={clientiSearch} variables={variablesCsv} fetchPolicy="network-only">
                              {({ loading: loadingCsv, error: errorCsv, data: dataCsv }) => {
                                if (loadingCsv) return <p>Preparazione file in corso...</p>
                                if (errorCsv) return <p>Errore :(</p>

                                const dataCsvOk = dataCsv.clientiSearch.nodes.map((c) => ({
                                  nome: c.nome,
                                  telefono: c.telefono,
                                  telefono2: c.telefono2,
                                  email: c.email,
                                  email2: c.email2,
                                  agente: c.agente ? c.agente.nome : '',
                                }))

                                return (
                                  <div onClick={onHideCsv}>
                                    <CSVLink data={dataCsvOk} filename="clienti.csv" separator=";">
                                      Scarica file CSV &raquo;
                                    </CSVLink>
                                  </div>
                                )
                              }}
                            </Query>
                          </div>
                        )}

                        {!csvOpen && !csvEmailOpen && (
                          <Button color="primary" onClick={onShowCsvEmail}>
                            Prepara CSV con email
                          </Button>
                        )}

                        {!csvOpen && csvEmailOpen && (
                          <div style={{ marginTop: 20 }}>
                            <Query query={clientiEmailSearch} variables={variablesCsvEmail} fetchPolicy="network-only">
                              {({ loading: loadingCsv, error: errorCsv, data: dataCsv }) => {
                                if (loadingCsv) return <p>Preparazione file in corso...</p>
                                if (errorCsv) return <p>Errore :(</p>

                                const dataCsvOk = dataCsv.clientiEmailSearch.map((c) => ({
                                  email: c.email,
                                }))

                                return (
                                  <div onClick={onHideCsvEmail}>
                                    <CSVLink data={dataCsvOk} filename="email.csv" separator=";">
                                      Scarica file CSV con email &raquo;
                                    </CSVLink>
                                  </div>
                                )
                              }}
                            </Query>
                          </div>
                        )}
                      </React.Fragment>
                    )}
                    {!csvOpen && !csvEmailOpen && !csvNewsletterOpen && (
                      <Button color="primary" onClick={onShowCsvNewsletter}>
                        PREPARA CSV NEWSLETTER
                      </Button>
                    )}
                    {!csvOpen && !csvEmailOpen && csvNewsletterOpen && (
                      <div style={{ marginTop: 20 }}>
                        <Query query={clientiNewsletterSearch} variables={variablesCsvNl} fetchPolicy="network-only">
                          {({ loading: loadingCsv, error: errorCsv, data: dataCsv }) => {
                            if (loadingCsv) return <p>Preparazione file in corso...</p>
                            if (errorCsv) return <p>Errore :(</p>

                            const dataCsvNewsletter = dataCsv.clientiNewsletterSearch.map((c) => ({
                              nome: c.nome || '',
                              email: c.email || '',
                              telefono: c.telefono || '',
                            }))

                            const headersNewsletter = [
                              { label: 'Nome', key: 'nome' },
                              { label: 'Email', key: 'email' },
                              { label: 'Telefono', key: 'telefono' },
                            ]

                            return (
                              <div onClick={onHideCsvNewsletter}>
                                <CSVLink data={dataCsvNewsletter} headers={headersNewsletter} filename="newsletter.csv" separator=";">
                                  Scarica file CSV Newsletter &raquo;
                                </CSVLink>
                              </div>
                            )
                          }}
                        </Query>
                      </div>
                    )}
                  </div>
                )
              }}
            </Query>
          </div>
        )
      }}
    </Query>
  )
}

class Clienti extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      quantoInteressato: '',
      agenteSelezionato: '',
      csvOpen: false,
      csvEmailOpen: false,
      showAdvancedFilters: false,
      zoneSelezionate: [],
      iscrittoDa: '',
      nascondiProposteAcquisto: '',
      provenienza: '',
      portalFilter: getStoredPortalFilter(),
      csvNewsletterOpen: false,
    }
  }
  toggleAdvancedFilters = (event) => {
    event.preventDefault()
    this.setState((s) => ({ showAdvancedFilters: !s.showAdvancedFilters }))
  }

  handleChangeSearchQueryDebounced = _debounce((event, mutate) => {
    mutate({
      variables: { clientiUI: { searchQueryDebounced: event.target.value } },
    })
  }, 400)

  handleChangeSearchQuery = (mutate) => (event) => {
    event.persist()
    mutate({
      variables: { clientiUI: { searchQuery: event.target.value, page: 1 } },
    })

    this.handleChangeSearchQueryDebounced(event, mutate)
  }

  handlePageChange =
    (mutate) =>
    ({ selected }) => {
      mutate({ variables: { clientiUI: { page: selected + 1 } } })
    }

  handleNuovoCliente = (event) => {
    event.preventDefault()
    this.props.history.push('/nuovo-cliente')
  }

  handleOnlyDaRicontattareCheckbox = (mutate) => (event) => {
    mutate({
      variables: { clientiUI: { onlyDaRicontattare: event.target.checked } },
    })
  }

  handleChangeOption = (field, mutate) => (option) => {
    mutate({
      variables: { clientiUI: { [field]: option ? option.value : '' } },
    })
  }

  handleChangeZoneSelezionate = (mutate) => (options) => {
    const selected = Array.isArray(options) ? options : []
    if (selected.length > 13) return // max 13
    this.setState({ zoneSelezionate: selected })

    mutate({ variables: { clientiUI: { page: 1 } } })
  }

  handleChangeIscrittoDa = (mutate) => (event) => {
    this.setState({ iscrittoDa: event.target.value })
    mutate({ variables: { clientiUI: { page: 1 } } })
  }

  handleChangeNascondiProposteAcquisto = (mutate) => (event) => {
    this.setState({ nascondiProposteAcquisto: event.target.value })
    mutate({ variables: { clientiUI: { page: 1 } } })
  }

  handleChangeProvenienza = (mutate) => (event) => {
    this.setState({ provenienza: event.target.value })
    mutate({ variables: { clientiUI: { page: 1 } } })
  }

  handleChangePortalFilter = (mutate) => (portalFilter) => {
    this.setState({ portalFilter })
    mutate({ variables: { clientiUI: { page: 1 } } })
  }

  handleChangeQuantoInteressato = (event) => {
    this.setState({
      quantoInteressato: event.target.value,
    })
  }

  handleChangeAgenteSelezionato = (event) => {
    this.setState({
      agenteSelezionato: event.target.value,
    })
  }

  handleChangeSortField = (mutate, sortFields) => (field) => (event) => {
    let direction = '_ASC'
    if (sortFields[0] === field + '_ASC') {
      direction = '_DESC'
    }
    mutate({ variables: { clientiUI: { sortFields: [field + direction] } } })
  }

  handleShowCsv = () => {
    this.setState({
      csvOpen: true,
    })
  }

  handleHideCsv = () => {
    this.setState({
      csvOpen: false,
    })
  }

  handleShowCsvEmail = () => {
    this.setState({
      csvEmailOpen: true,
    })
  }

  handleHideCsvEmail = () => {
    this.setState({
      csvEmailOpen: false,
    })
  }

  handleShowCsvNewsletter = () => {
    this.setState({
      csvNewsletterOpen: true,
      csvOpen: false,
      csvEmailOpen: false,
    })
  }

  handleHideCsvNewsletter = () => {
    this.setState({
      csvNewsletterOpen: false,
    })
  }

  render() {
    const { classes } = this.props

    return (
      <Query query={clientiUI}>
        {({ loading, error, data: { clientiUI } }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>
          return (
            <Mutation mutation={updateClientiUI}>
              {(mutate) => (
                <GridContainer>
                  <ItemGrid xs={12}>
                    <IconCard
                      icon={RecentActors}
                      iconColor="blue"
                      title="Clienti"
                      filter={
                        <PortalFilter
                          value={this.state.portalFilter}
                          onChange={this.handleChangePortalFilter(mutate)}
                          style={{ width: 210, maxWidth: '100%', margin: '0 0 15px auto' }}
                        />
                      }
                      content={
                        <div>
                          <Query query={miniMe}>
                            {({ loading, error, data: { me } }) => {
                              if (loading) return <p>Loading...</p>
                              if (error) return <p>Error :(</p>

                              const isAgente = me.ruolo === 'AGENTE'

                              return (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: isAgente ? 'flex-end' : 'space-between', flexWrap: 'wrap' }}>
                                  {!isAgente && (
                                    <Button variant="raised" color="primary" onClick={this.handleNuovoCliente} style={{ margin: '20px 40px 20px 0' }}>
                                      <Add /> Aggiungi cliente
                                    </Button>
                                  )}
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', marginLeft: 'auto' }}>
                                    {!isAgente && (
                                      <div style={{ minWidth: 200, marginRight: 24 }}>
                                        <Query
                                          query={agenti}
                                          variables={{
                                            limit: 50,
                                          }}
                                        >
                                          {({ loading, error, data }) => {
                                            if (loading) return <p>Loading...</p>
                                            if (error) return <p>Error :(</p>

                                            const options = [
                                              {
                                                value: '',
                                                label: '-- Seleziona --',
                                              },
                                              ...data.utenti.nodes.map((agente) => ({
                                                value: agente.id,
                                                label: agente.nome,
                                              })),
                                            ]

                                            return (
                                              <TextField id="utenteId" label="Agente" select fullWidth value={this.state.agenteSelezionato} onChange={this.handleChangeAgenteSelezionato}>
                                                {options &&
                                                  options.map((option) => {
                                                    return (
                                                      <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                      </MenuItem>
                                                    )
                                                  })}
                                              </TextField>
                                            )
                                          }}
                                        </Query>
                                      </div>
                                    )}
                                    <FiltroClienti
                                      value={clientiUI.searchQuery}
                                      onChange={this.handleChangeSearchQuery(mutate)}
                                      style={{ float: 'none', marginTop: 0, minWidth: 210 }}
                                    />
                                  </div>
                                </div>
                              )
                            }}
                          </Query>

                          <div
                            style={{
                              marginTop: 20,
                              marginBottom: 10,
                              padding: '5px 10px',
                              border: '2px solid #26c6da',
                              borderRadius: 6,
                              backgroundColor: '#e8f6f7',
                            }}
                          >
                            <GridContainer>
                              <ItemGrid xs={2}>
                                <FormControlLabel control={<Checkbox checked={clientiUI.onlyDaRicontattare} onChange={this.handleOnlyDaRicontattareCheckbox(mutate)} value="onlyDaRicontattare" color="primary" />} label="Da ricontattare" />
                              </ItemGrid>
                              <ItemGrid xs={2}>
                                <FormControl className={classes.formControl} style={{ width: '100%' }}>
                                  <SimpleSelect
                                    displayEmpty
                                    className={classes.selectEmpty}
                                    value={this.state.quantoInteressato}
                                    onChange={this.handleChangeQuantoInteressato}
                                    style={{
                                      marginTop: 5,
                                      backgroundColor: '#fff',
                                      borderColor: '#d9d9d9 #ccc #b3b3b3',
                                      borderRadius: 4,
                                      border: '1px solid #ccc',
                                      color: '#aaa',
                                      fontSize: 14,
                                      height: 36,
                                      padding: '2px 5px 0 10px',
                                    }}
                                  >
                                    <MenuItem value="">Quanto interessato</MenuItem>
                                    <MenuItem value={5}>
                                      <span role="img" aria-label="5stars">
                                        ⭐⭐⭐⭐⭐
                                      </span>
                                    </MenuItem>
                                    <MenuItem value={4}>
                                      <span role="img" aria-label="4stars">
                                        ⭐⭐⭐⭐
                                      </span>
                                    </MenuItem>
                                    <MenuItem value={3}>
                                      <span role="img" aria-label="3stars">
                                        ⭐⭐⭐
                                      </span>
                                    </MenuItem>
                                    <MenuItem value={2}>
                                      <span role="img" aria-label="2stars">
                                        ⭐⭐
                                      </span>
                                    </MenuItem>
                                    <MenuItem value={1}>
                                      <span role="img" aria-label="1star">
                                        ⭐
                                      </span>
                                    </MenuItem>
                                    <MenuItem value={0}>
                                      <span role="img" aria-label="0stars">
                                        ❌
                                      </span>
                                    </MenuItem>
                                  </SimpleSelect>
                                </FormControl>
                              </ItemGrid>
                              <ItemGrid xs={4}>
                                <Query query={zone} fetchPolicy="cache-and-network">
                                  {({ loading, error, data }) => {
                                    if (loading) return <p>Caricamento zone...</p>
                                    if (error) return <p>Errore :(</p>
                                    return (
                                      <div style={{ marginTop: 5 }}>
                                        <Select
                                          multi
                                          closeOnSelect={false}
                                          options={data.allZone.map((zona) => ({
                                            value: zona.nome,
                                            label: zona.nome,
                                          }))}
                                          value={this.state.zoneSelezionate}
                                          onChange={this.handleChangeZoneSelezionate(mutate)}
                                          placeholder="Zone (max 13)"
                                        />
                                      </div>
                                    )
                                  }}
                                </Query>
                              </ItemGrid>
                              <ItemGrid xs={4}>
                                <Query query={interessi} fetchPolicy="cache-and-network">
                                  {({ loading, error, data }) => {
                                    if (loading) return <p>Caricamento interessi...</p>
                                    if (error) return <p>Errore :(</p>
                                    data.allInteressi = data.allInteressi.filter((i) => i.nome !== '')
                                    return (
                                      <Select
                                        options={data.allInteressi.map((interesse) => ({
                                          value: interesse.nome,
                                          label: interesse.nome,
                                        }))}
                                        value={clientiUI.interesse}
                                        onChange={this.handleChangeOption('interesse', mutate)}
                                        style={{ marginTop: 5 }}
                                        placeholder="Interesse"
                                      />
                                    )
                                  }}
                                </Query>
                              </ItemGrid>

                              <ItemGrid xs={12}>
                                <div style={{ marginTop: 10, marginBottom: 10 }}>
                                  <a href="#" onClick={this.toggleAdvancedFilters} style={{ color: '#007b8a', fontWeight: 600, textDecoration: 'none' }}>
                                    {this.state.showAdvancedFilters ? 'Nascondi filtri avanzati ▲' : 'Filtri avanzati ▼'}
                                  </a>
                                </div>
                              </ItemGrid>

                              {this.state.showAdvancedFilters && (
                                <React.Fragment>
                                  <ItemGrid xs={2}>
                                    <FormControl className={classes.formControl} style={{ width: '100%' }}>
                                      <SimpleSelect
                                        displayEmpty
                                        className={classes.selectEmpty}
                                        value={this.state.iscrittoDa}
                                        onChange={this.handleChangeIscrittoDa(mutate)}
                                        style={{
                                          marginTop: 5,
                                          backgroundColor: '#fff',
                                          borderColor: '#d9d9d9 #ccc #b3b3b3',
                                          borderRadius: 4,
                                          border: '1px solid #ccc',
                                          color: '#aaa',
                                          fontSize: 14,
                                          height: 36,
                                          padding: '2px 5px 0 10px',
                                        }}
                                        placeholder="Iscritto da"
                                      >
                                        <MenuItem value="">Iscritto da</MenuItem>
                                        <MenuItem value="TUTTI">Tutti</MenuItem>
                                        <MenuItem value="ULTIMO_MESE">Ultimo mese</MenuItem>
                                        <MenuItem value="ULTIMI_6_MESI">Ultimi 6 mesi</MenuItem>
                                      </SimpleSelect>
                                    </FormControl>
                                  </ItemGrid>

                                  <ItemGrid xs={2}>
                                    <FormControl className={classes.formControl} style={{ width: '100%' }}>
                                      <SimpleSelect
                                        displayEmpty
                                        className={classes.selectEmpty}
                                        value={this.state.nascondiProposteAcquisto}
                                        onChange={this.handleChangeNascondiProposteAcquisto(mutate)}
                                        style={{
                                          marginTop: 5,
                                          backgroundColor: '#fff',
                                          borderColor: '#d9d9d9 #ccc #b3b3b3',
                                          borderRadius: 4,
                                          border: '1px solid #ccc',
                                          color: '#aaa',
                                          fontSize: 14,
                                          height: 36,
                                          padding: '2px 5px 0 10px',
                                        }}
                                        placeholder="Nascondi utenti con proposte di acquisto"
                                      >
                                        <MenuItem value="">Nascondi utenti con proposte di acquisto</MenuItem>
                                        <MenuItem value="NESSUNO">Nessuno</MenuItem>
                                        <MenuItem value="TUTTI">Tutti</MenuItem>
                                        <MenuItem value="ULTIMI_3_ANNI">Ultimi 3 anni</MenuItem>
                                        <MenuItem value="ULTIMI_6_MESI">Ultimi 6 mesi</MenuItem>
                                      </SimpleSelect>
                                    </FormControl>
                                  </ItemGrid>

                                  <ItemGrid xs={2}>
                                    <FormControl className={classes.formControl} style={{ width: '100%' }}>
                                      <SimpleSelect
                                        displayEmpty
                                        className={classes.selectEmpty}
                                        value={this.state.provenienza}
                                        onChange={this.handleChangeProvenienza(mutate)}
                                        style={{
                                          marginTop: 5,
                                          backgroundColor: '#fff',
                                          borderColor: '#d9d9d9 #ccc #b3b3b3',
                                          borderRadius: 4,
                                          border: '1px solid #ccc',
                                          color: '#aaa',
                                          fontSize: 14,
                                          height: 36,
                                          padding: '2px 5px 0 10px',
                                        }}
                                        placeholder="Provenienza"
                                      >
                                        <MenuItem value="">Provenienza</MenuItem>
                                        <MenuItem value="TUTTI">Tutti</MenuItem>
                                        <MenuItem value="ITALIANI_SVIZZERI">Italiani / Svizzeri</MenuItem>
                                        <MenuItem value="ESTERO">Estero</MenuItem>
                                      </SimpleSelect>
                                    </FormControl>
                                  </ItemGrid>
                                  <ItemGrid xs={2}>
                                    <Query query={zone} fetchPolicy="cache-and-network">
                                      {({ loading, error, data }) => {
                                        if (loading) return <p>Caricamento zone...</p>
                                        if (error) return <p>Errore :(</p>
                                        return (
                                          <Select
                                            options={data.allZone.map((zona) => ({
                                              value: zona.nome,
                                              label: zona.nome,
                                            }))}
                                            value={clientiUI.zonaEsclusa}
                                            onChange={this.handleChangeOption('zonaEsclusa', mutate)}
                                            style={{ marginTop: 5 }}
                                            placeholder="Escludi Zona"
                                          />
                                        )
                                      }}
                                    </Query>
                                  </ItemGrid>
                                  <ItemGrid xs={2}>
                                    <Query query={interessi} fetchPolicy="cache-and-network">
                                      {({ loading, error, data }) => {
                                        if (loading) return <p>Caricamento interessi...</p>
                                        if (error) return <p>Errore :(</p>
                                        return (
                                          <Select
                                            options={data.allInteressi.map((interesse) => ({
                                              value: interesse.nome,
                                              label: interesse.nome,
                                            }))}
                                            value={clientiUI.interesseEscluso || undefined}
                                            onChange={this.handleChangeOption('interesseEscluso', mutate)}
                                            style={{ marginTop: 5 }}
                                            placeholder="Escludi Interesse"
                                          />
                                        )
                                      }}
                                    </Query>
                                  </ItemGrid>
                                </React.Fragment>
                              )}
                            </GridContainer>
                          </div>

                          <TableClienti
                            classes={classes}
                            searchQuery={clientiUI.searchQueryDebounced}
                            onlyDaRicontattare={clientiUI.onlyDaRicontattare}
                            quantoInteressato={this.state.quantoInteressato}
                            agenteSelezionato={this.state.agenteSelezionato}
                            zoneMulti={this.state.zoneSelezionate.map((z) => z.value)}
                            interesse={clientiUI.interesse}
                            zonaEsclusa={clientiUI.zonaEsclusa}
                            interesseEscluso={clientiUI.interesseEscluso}
                            iscrittoDa={this.state.iscrittoDa}
                            nascondiProposteAcquisto={this.state.nascondiProposteAcquisto}
                            provenienza={this.state.provenienza}
                            portalFilter={this.state.portalFilter}
                            sortFields={clientiUI.sortFields}
                            onChangeSortField={this.handleChangeSortField(mutate, clientiUI.sortFields)}
                            page={clientiUI.page}
                            onPageChange={this.handlePageChange(mutate)}
                            onShowCsv={this.handleShowCsv}
                            onHideCsv={this.handleHideCsv}
                            onShowCsvEmail={this.handleShowCsvEmail}
                            onHideCsvEmail={this.handleHideCsvEmail}
                            csvOpen={this.state.csvOpen}
                            csvEmailOpen={this.state.csvEmailOpen}
                            csvNewsletterOpen={this.state.csvNewsletterOpen}
                            onShowCsvNewsletter={this.handleShowCsvNewsletter}
                            onHideCsvNewsletter={this.handleHideCsvNewsletter}
                          />
                        </div>
                      }
                    />
                  </ItemGrid>
                </GridContainer>
              )}
            </Mutation>
          )
        }}
      </Query>
    )
  }
}

export default withStyles(tableStyle)(Clienti)



// WEBPACK FOOTER //
// ./src/views/App/Clienti/Clienti.jsx